import { createFileRoute } from '@tanstack/react-router';
import { MfaMethodChooser } from '../../components/auth/MfaMethodChooser';
import { AuthLayout } from '../../components/layouts/AuthLayout';

export const Route = createFileRoute('/_authenticated/_layout/me/security/mfa-setup')({
    component: () => (
        <AuthLayout>
            <MfaMethodChooser />
        </AuthLayout>
    ),
});
